(function () {
  var activeTrigger = null;
  var closeTimer = null;
  var FOCUSABLE_SELECTOR = [
    'a[href]',
    'area[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'iframe',
    '[tabindex]:not([tabindex="-1"])',
    '[contenteditable="true"]'
  ].join(',');

  function getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }

  function lockBody() {
    var width = getScrollbarWidth();
    if (width > 0) document.body.style.paddingRight = width + 'px';
    document.body.classList.add('smart-size-guide-no-scroll');
  }

  function unlockBody() {
    document.body.classList.remove('smart-size-guide-no-scroll');
    document.body.style.paddingRight = '';
  }

  function getDialog(modal) {
    return modal ? modal.querySelector('.smart-size-guide-modal__dialog') : null;
  }

  function getFocusableElements(container) {
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter(function (element) {
      return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    });
  }

  function setTriggerExpanded(trigger, expanded) {
    if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function closeModal(modal, shouldReturnFocus) {
    if (!modal || modal.hidden) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    var trigger = activeTrigger;
    setTriggerExpanded(trigger, false);
    unlockBody();

    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(function () {
      modal.hidden = true;
      if (shouldReturnFocus !== false && trigger && document.contains(trigger)) {
        trigger.focus({ preventScroll: true });
      }
      activeTrigger = null;
    }, 190);
  }

  function closeAll(shouldReturnFocus) {
    document.querySelectorAll('[data-smart-size-guide-modal]:not([hidden])').forEach(function (modal) {
      closeModal(modal, shouldReturnFocus);
    });
  }

  function openModal(modal, trigger) {
    if (!modal) return;

    closeAll(false);
    activeTrigger = trigger || null;
    setTriggerExpanded(activeTrigger, true);
    lockBody();

    window.clearTimeout(closeTimer);
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');

    window.requestAnimationFrame(function () {
      modal.classList.add('is-open');
      var dialog = getDialog(modal);
      var focusable = getFocusableElements(dialog);
      var closeButton = modal.querySelector('[data-smart-size-guide-close]:not(.smart-size-guide-modal__overlay)');
      if (closeButton) {
        closeButton.focus({ preventScroll: true });
      } else if (focusable.length) {
        focusable[0].focus({ preventScroll: true });
      } else if (dialog) {
        dialog.focus({ preventScroll: true });
      }
    });
  }

  function handleTrapFocus(event) {
    if (event.key !== 'Tab') return;

    var modal = document.querySelector('[data-smart-size-guide-modal].is-open');
    if (!modal) return;

    var dialog = getDialog(modal);
    var focusable = getFocusableElements(dialog);
    if (!focusable.length) {
      event.preventDefault();
      if (dialog) dialog.focus({ preventScroll: true });
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus({ preventScroll: true });
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus({ preventScroll: true });
    }
  }

  function initSmartSizeGuide(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-smart-size-guide-open]').forEach(function (trigger) {
      if (trigger.dataset.smartSizeGuideBound === 'true') return;
      trigger.dataset.smartSizeGuideBound = 'true';

      trigger.addEventListener('click', function () {
        var modalId = trigger.getAttribute('data-smart-size-guide-open');
        var modal = modalId ? document.getElementById(modalId) : null;
        openModal(modal, trigger);
      });
    });

    scope.querySelectorAll('[data-smart-size-guide-close]').forEach(function (button) {
      if (button.dataset.smartSizeGuideCloseBound === 'true') return;
      button.dataset.smartSizeGuideCloseBound = 'true';

      button.addEventListener('click', function () {
        closeModal(button.closest('[data-smart-size-guide-modal]'), true);
      });
    });
  }

  if (!document.documentElement.dataset.smartSizeGuideGlobalBound) {
    document.documentElement.dataset.smartSizeGuideGlobalBound = 'true';

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAll(true);
      }
      handleTrapFocus(event);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSmartSizeGuide(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initSmartSizeGuide(event.target);
  });
})();
